var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import { useOutlet } from "react-router";
/**
 * Affichage du contenu principal de la page
 * @returns
 */
export default function PasswordSettingPage() {
    var outlet = useOutlet();
    return (_jsxs("div", __assign({ className: "layout overflow-hidden flex flex-col w-full h-full page " }, { children: [_jsx(Header, {}), _jsx("div", __assign({ className: "flex h-full flex-row flex-auto overflow-hidden" }, { children: _jsx("div", __assign({ className: "flex flex-col w-full" }, { children: outlet })) })), _jsx(Footer, {})] })));
}
